import { Component, Input, Output, EventEmitter, ViewChild, SimpleChanges, ChangeDetectorRef } from '@angular/core';
import { CourseService } from '../../services/course.service';
import { CoursePersistenceService } from '../../services/course-persistence.service';
import { sessionAttendeeDTO } from '../../models/sessionAttendeeDTO';
import { ConfirmationService, MenuItem, MessageService } from 'primeng/api';
import { SessionAttendeeParticipationConstants } from '../../constants/sessionAttendeeParticipation.constants';
import { SessionAttendeePassOrFailConstants } from '../../constants/sessionAttendeePassOrFail.constants';
import { CourseConstants } from '../../constants/course.constants';
import { cloneDeep } from 'lodash-es';
import { SessionAttendeesEnrollModalComponent } from '../session-attendees-enroll-modal/session-attendees-enroll-modal.component';
import { CourseScoringOptionConstants } from '../../constants/courseScoringOption.constants';
import { SessionAttendeesEnrollDetails } from '../../models/session-attendees-enroll-details';
import { TreeModule } from 'primeng/tree';

@Component({
  selector: 'app-session-attendee',
  templateUrl: './session-attendee.component.html',
  styleUrls: ['./session-attendee.component.scss']
})
export class SessionAttendeeComponent {

  @Input() sessionId:any;
  @Input() isSessionAttendeeSliderOpen: boolean = false;
  @Input() SliderHeader: string = "";
  @Input() courseNumber !: string;
  @Output() isSessionAttendeeSliderActive = new EventEmitter<boolean>();
  @Input() minimumPassingScore: string | null = null;
  @Input() ScoringOption: string | null = null;
  @Input() ProficiencyQuiz: string | null = null;
  @ViewChild(SessionAttendeesEnrollModalComponent)
  private sessionAttendeesEnrollModalComponent!: SessionAttendeesEnrollModalComponent;
  isSessionSliderOpen: boolean = false;
  showAllAttendees: boolean = false;
  sessionAttendeesData: sessionAttendeeDTO[] = [];
  sessionAttendeesOriginalData: sessionAttendeeDTO[] = [];
  selectedsessionAttendeesDataSet : sessionAttendeeDTO[] = [];
  Participation: MenuItem[] = [];
  PassOrFail: MenuItem[] = [];
  SaveButtonLabel = "Save";
  saveButtonDisable: boolean = true;
  splitButtonDisable: boolean = true;
  errorMessages: string[] = [];
  errorMessageHeaderText: string = CourseConstants.Session_AttendeePassOrFailUpdate_Error;
  descreption: string = '';
  showLoader: boolean = false;
  changeInPassOrFail : boolean = false;
  changeInParticipation : boolean = false;
  splitButtonDisableForPassOrFail : boolean = false;
  sessionAttendeesEnrollDetails:SessionAttendeesEnrollDetails = {} as SessionAttendeesEnrollDetails;
  isCompleteDateModalVisible:boolean=false;
  passedAttendeesList: sessionAttendeeDTO[] = [];

  ngOnInit(){
    this.coursePersistenceService.closeAndResetSessionAttendeeSlider$.subscribe((isSessionSliderClose) => {
      if(isSessionSliderClose){ this.closeAndResetCourseSlider(); }
    });
    if(this.ScoringOption == CourseScoringOptionConstants.MinimumScore_Name){
      this.splitButtonDisableForPassOrFail = true;
    }
    else{
      this.splitButtonDisableForPassOrFail = this.splitButtonDisable;
    }

  }

  ngOnChanges(changes: SimpleChanges) {
    // Only fetch data when the slider is opened AND sessionId is available
    if (changes['isSessionAttendeeSliderOpen']?.currentValue && this.sessionId) {
      this.getSessionAttendeeData(false);
    }
  }

  constructor(private courseService: CourseService, private coursePersistenceService : CoursePersistenceService, 
    private confirmationService: ConfirmationService, private messageService: MessageService, private cdr: ChangeDetectorRef){
    this.Participation = [
      {
        label: 'Attended',
        command: this.attended
      },
      {
        label: 'Absent',
        command: this.absent
      },
      {
        label: 'Enrolled',
        command: this.enrolled
      },
      {
        label: 'Withdrawn',
        command: this.withdrawn
      },
      {
        label: 'Waitlist',
        command: this.waitlist
      },
    ]

    this.PassOrFail = [
      {
        label: 'Pass',
        command: this.pass
      },
      {
        label: 'Fail',
        command: this.fail
      },
    ]
  }

  getSessionAttendeeData(showAll: boolean){
    this.showLoader = true;
    this.showAllAttendees = showAll;
    this.courseService.getSessionAttendeeDetail(this.sessionId, showAll).subscribe((data) =>{
      this.sessionAttendeesData = data;
      this.sessionAttendeesOriginalData = cloneDeep(data);
      this.showLoader = false;
    });
  }

  getSelectedItems(selectedItems: sessionAttendeeDTO[]){
    this.selectedsessionAttendeesDataSet = []
    if(selectedItems.length > 0){
      this.splitButtonDisable = false;
      if(this.ScoringOption != CourseScoringOptionConstants.MinimumScore_Name){
        this.splitButtonDisableForPassOrFail = false;
      }
    }
    else{
      this.splitButtonDisable = true;
    this.splitButtonDisableForPassOrFail= true;
    }
      
    this.selectedsessionAttendeesDataSet = selectedItems;
  }

  getGradeChange(updateInGrade: boolean){
    this.saveButtonDisable = !updateInGrade;
  }

  closeSliderConfirmation(){
    this.coursePersistenceService.openConfirmationDialogForSessionAttendee();
  }

  closeAndResetCourseSlider(){
    this.isSessionSliderOpen = false;
    this.isSessionAttendeeSliderActive.emit(this.isSessionSliderOpen);
  }

  // common method to update Participation
  private UpdateParticipation(participation: string){
    let waitlistAttendeeCount = 0;
    if(participation == SessionAttendeeParticipationConstants.ParticipationName_Withdrawn){
      // Check if any Attendee participation is in Waitlist
      this.sessionAttendeesData.filter((key) =>{
        key.participation == SessionAttendeeParticipationConstants.ParticipationName_Waitlist;
        waitlistAttendeeCount++;
      });

      if(waitlistAttendeeCount > 0){
        this.confirmationService.confirm({
          message: CourseConstants.Session_Attendee_WaitlistParticipationUpdate_Confirmation,
          header: CourseConstants.Course_Slider_Confirmation_Header,
          icon: 'pi pi-exclamation-triangle',
          acceptIcon: 'pi pi-check',
          rejectIcon: 'pi pi-times',
          accept: () => {
            this.UpdateParticipationIfPasses(participation);
          },
        });
      }
      else{
        this.UpdateParticipationIfPasses(participation);
      }
    }
    else{
      this.UpdateParticipationIfPasses(participation);
    }
  }

  private UpdateParticipationIfPasses(participation: string){
    this.errorMessages = [];
    this.selectedsessionAttendeesDataSet.forEach((ele) => {
      this.sessionAttendeesData.filter((key) => {
        if(key.attendee === ele.attendee){
          if(key.participation != participation || key.grade != ele.grade){
            key.participation = participation;
            key.grade = ele.grade;
            this.changeInParticipation = true;
          }
        }
      });
    });
  
    if(this.changeInParticipation)
      this.saveButtonDisable = false;
  }

  // common method to update pass or fail
  private UpdatePassOrFail(passOrFail: string){
    this.errorMessages = [];
    this.selectedsessionAttendeesDataSet.forEach((ele) => {
      this.sessionAttendeesData.filter((key) => {
        if(key.attendee === ele.attendee){
          if(key.participation == SessionAttendeeParticipationConstants.ParticipationName_Absent 
            || key.participation == SessionAttendeeParticipationConstants.ParticipationName_Waitlist
            || key.participation == SessionAttendeeParticipationConstants.ParticipationName_Withdrawn){
              this.errorMessages.push(key.attendee);
          }
          else{
            if(key.passOrFail != passOrFail){
              key.passOrFail = passOrFail;
              this.changeInPassOrFail = true;
              //Push the selected passed attendees
              if(passOrFail===SessionAttendeePassOrFailConstants.AttendeeStatus_Pass)
              {
                this.passedAttendeesList.push(key);
              }
            }
          }
          if(key.passOrFail == SessionAttendeePassOrFailConstants.AttendeeStatus_Fail){
                this.sessionAttendeesOriginalData.filter(a=>{
                  if(ele.attendee == a.attendee && a.passOrFail == SessionAttendeePassOrFailConstants.AttendeeStatus_Pass){
                    this.errorMessageHeaderText = CourseConstants.Session_Attendee_PassAttendeeValidation;
                    this.errorMessages.push(a.attendee);
                    key.passOrFail = SessionAttendeePassOrFailConstants.AttendeeStatus_Pass;
                  }
                })
                
              }
          
          if(key.grade != ele.grade){
            key.grade = ele.grade;
            this.changeInPassOrFail = true;
          }
        }
      });
    });

    if(this.errorMessages.length > 0){
      document.querySelector('.formwrap')?.scrollTo(0, 0);
    }

    if(this.changeInPassOrFail)
      this.saveButtonDisable = false;
      this.coursePersistenceService.sendSelectedPassedAttendees(this.passedAttendeesList);
  }

  // Update Participation
  attended = () => {
    this.UpdateParticipation(SessionAttendeeParticipationConstants.ParticipationName_Attended);
  }
  
  absent = () => {
    this.UpdateParticipation(SessionAttendeeParticipationConstants.ParticipationName_Absent);
  }
  
  enrolled = () => {
    this.UpdateParticipation(SessionAttendeeParticipationConstants.ParticipationName_Enrolled);
  }
  
  withdrawn = () => {
    this.UpdateParticipation(SessionAttendeeParticipationConstants.ParticipationName_Withdrawn);
  }
  
  waitlist = () => {
    this.UpdateParticipation(SessionAttendeeParticipationConstants.ParticipationName_Waitlist);
  }
  
  // Update Pass or Fail
  pass = () => {
    this.UpdatePassOrFail(SessionAttendeePassOrFailConstants.AttendeeStatus_Pass);
  }
  
  fail = () => {
    this.UpdatePassOrFail(SessionAttendeePassOrFailConstants.AttendeeStatus_Fail);
  }

  // Save changes in Attendee Panel list
  SaveChanges(){
    if(this.changeInPassOrFail || this.validateSessionForGradingPassOrFail()){
      this.coursePersistenceService.openConfirmationDialogForSessionAttendeeUpdate(this.sessionId, this.sessionAttendeesData);
    }
    else{
      this.coursePersistenceService.upateSessionAttendee(this.sessionId, this.sessionAttendeesData);
    }
  }

  validateSessionForGradingPassOrFail(): boolean {
    // Ensure minimumPassingScore is valid
    if (this.minimumPassingScore == null) return false;
  
    // Convert minimumPassingScore to a number (assuming it's a string with a '%' symbol)
    const passingScore = Number(this.minimumPassingScore.replace('%', '').trim());
  
    // Map for quick lookup of attendees in sessionAttendeesOriginalData
    const attendeesMap = new Map(
      this.sessionAttendeesOriginalData.map(attendee => [attendee.attendee, attendee])
    );
  
    // Check each attendee in sessionAttendeesData
    for (const data of this.sessionAttendeesData) {
      const originalAttendee = attendeesMap.get(data.attendee);
  
      if (originalAttendee) {
        // Check if there is a grade change and if the new grade meets the passing score
        if (
          (originalAttendee.grade === null && data.grade !== null) || // Grade was initially null, now it's set
          (originalAttendee.grade !== null && data.grade !== null && originalAttendee.grade !== data.grade) // Grade changed
        ) {
          if (data.grade != null && data.grade >= passingScore) {
            this.coursePersistenceService.passedAttendeesList.push(data);
          }
          this.coursePersistenceService.passingScore=passingScore;
        }
      }
    }
    return this.coursePersistenceService.passedAttendeesList.length>0;
  }
  
  displayTrainingCompleteDateModal(event: any) {
    this.isCompleteDateModalVisible = false;
  }

  openEnrollAttendeesPopUp = () => {
    this.sessionAttendeesEnrollModalComponent.openSessionAttendeeModal(this.sessionId[0]);
  }

updateSessionAttendees = () => {
  this.sessionAttendeesEnrollDetails.usersEnrolled = this.sessionAttendeesEnrollModalComponent.selectedAttendees;
  this.sessionAttendeesEnrollDetails.sessionAttendees = this.sessionAttendeesData;
  this.sessionAttendeesEnrollDetails.sessionId = this.sessionId[0];
  this.sessionAttendeesEnrollDetails.showAll = this.showAllAttendees;
  this.sessionAttendeesEnrollModalComponent.closeModal();
  this.showLoader = true;

  this.courseService.updateSessionAttendeesOnEnrollment(this.sessionAttendeesEnrollDetails)
    .subscribe((data: any) => {
      if (data.attendees && data.attendees.length > 0) {
        const validAttendees = data.attendees;
        this.sessionAttendeesData = [...validAttendees];
        this.sessionAttendeesOriginalData = cloneDeep(validAttendees);
      }

      // Clear previous error toasts before showing a new one
      this.messageService.clear('enrollError');

      if (data.invalidUsers && data.invalidUsers.length > 0) {
        const invalidList = Array.from(new Set(data.invalidUsers)).join(', ');
        const formattedMessage =
          CourseConstants.Enroll_Users_Error_message.replace('[0]', invalidList);

        this.messageService.add({
          key: 'enrollError',
          severity: CourseConstants.Severity_Error,
          summary: formattedMessage,
          sticky: true
        });
      }

      this.showLoader = false;
      this.saveButtonDisable = false;
    }, (error) => {
      this.showLoader = false;
      this.saveButtonDisable = false;
      this.messageService.clear('enrollError');
      this.messageService.add({
        key: 'enrollError',
        severity: CourseConstants.Severity_Error,
        summary: CourseConstants.Attendee_Failure_Error_Message,
        sticky: true
      });
    });
}


}
